import { useQuery } from 'react-query';

// import adm
import adminAxiosInstance from 'services/API/ADMINAPI';

// our api urls
import { getLoanApplicationsByUserIdUrl } from 'shared/api-urls';

// our query keys
import { PYLON_CLIENT_LOAN_APPLICATIONS } from 'shared/query-keys';

function useGetLoanApplicationsByUserId(
	clientId,
	enabled = false,
	selector = (data) => data
) {
	return useQuery(
		[PYLON_CLIENT_LOAN_APPLICATIONS, clientId],
		async () => {
			const res = await adminAxiosInstance.get(
				`${getLoanApplicationsByUserIdUrl}?client-id=${clientId}`
			);

			const loanApplicationData = res.data;

			const sortedApplications =
				loanApplicationData.loanApplications.sort(
					(a, b) =>
						new Date(b.creationDate) - new Date(a.creationDate)
				);

			return {
				...loanApplicationData,
				loanApplications: sortedApplications
			};
		},
		{
			enabled,
			select: selector
		}
	);
}

export default useGetLoanApplicationsByUserId;
